import React from 'react';
import PropTypes from 'prop-types';
import Breadcrumb from '../../../core/layout/Breadcrumb';
import Card from '../../../core/layout/Card';
import LocalizationListContainer from './LocalizationListContainer';
import LocalizationListFilterContainer from './LocalizationListFilterContainer';
import { browserHistory } from 'react-router';
import Button from '../../../core/form/Button';
import { Dropdown, Menu } from 'antd';
import Icon from '../../../core/layout/Icon';
import ColumnSeparator from '../../../core/layout/ColumnSeparator';
import ExportCsvDialogContainer from './ExportCsvDialogContainer';
import ImportCsvDialogContainer from './ImportCsvDialogContainer';

const LocalizationListScene = (props) => {
  const localizationActionsMenu = (
    <Menu>
      <Menu.Item key={0} onClick={props.handleExportCsvDialog}>
        <Icon name="download" /> Export CSV
      </Menu.Item>
      <Menu.Item key={1} onClick={props.handleImportCsvDialog}>
        <Icon name="upload" /> Import CSV
      </Menu.Item>
    </Menu>
  );

  return (
    <div>
      <Breadcrumb
        crumbs={[
          ...(props.location.state && props.location.state.from
            ? [{ text: props.location.state.from.text, link: props.location.state.from.pathname }]
            : []),
          {
            text: 'Localization',
          },
        ]}
      />
      <Card
        title="Localizations"
        actions={
          <div>
            <Dropdown overlay={localizationActionsMenu} trigger={['click']} placement="bottomRight">
              <Button icon="file-excel" label={<Icon name="caret-down" style={{ marginLeft: '2px' }} />} />
            </Dropdown>
            <ColumnSeparator size="xs" />
            <Button
              type="primary"
              label="New item"
              icon="plus"
              onClick={() => browserHistory.push('/localization/new')}
            />
          </div>
        }
      >
        <LocalizationListFilterContainer initialFilters={props.location.query} />
        <LocalizationListContainer secondLocaleSelect={props.location.query.locale} />
        <ExportCsvDialogContainer />
        <ImportCsvDialogContainer />
      </Card>
    </div>
  );
};

LocalizationListScene.propTypes = {
  handleExportCsvDialog: PropTypes.func,
  handleImportCsvDialog: PropTypes.func,
  location: PropTypes.object,
};

export default LocalizationListScene;
